import {objectFromEntries, Values} from "@wix/devzai-utils-common";
import {DoppePremiumFeatures, DoppePremiumFeaturesSpec} from "./doppe-premium-features";
import {DoppePremiumFeaturesStatus} from "./doppe-premium";
import {
    wixPremiumBooleanFeatureStatusCreate,
    wixPremiumFeaturesStatusCreateFullyDisabled,
    wixPremiumFeaturesStatusCreateFullyEnabled,
    WixPremiumFeatureStatus,
    wixPremiumQuotaFeatureStatusCreate
} from "@wix/devzai-common-wix";

export const DoppeFreemiumPlan = {
    None: '00000000-0000-0000-0000-000000000000',
    /**
     * For users that joined before we had premium.
     */
    Legacy: 'fcfa9bc2-3f4c-49aa-b7cd-0a443312560a',
    /**
     * For users that joined after we had premium.
     */
    Default: 'fe6817ba-99b9-455c-b24f-c579b186d908'
} as const;

export type DoppeFreemiumPlan = Values<typeof DoppeFreemiumPlan>;

export namespace DoppeFreemiumPlan {

    export type Enabled = Exclude<DoppeFreemiumPlan, typeof DoppeFreemiumPlan.None>

}

export function doppeFreemiumPlanIsEnabled (freemiumPlan: DoppeFreemiumPlan) : freemiumPlan is DoppeFreemiumPlan.Enabled {
    return freemiumPlan !== DoppeFreemiumPlan.None;
}

function createPartialPremiumFeaturesStatus (
    statusesArr: WixPremiumFeatureStatus[]
) : Partial<DoppePremiumFeaturesStatus> {
    return objectFromEntries(statusesArr.map(status => [status.uniqueName, status]))
}

const DoppeFreemiumPlanFeaturesStatus = {
    [DoppeFreemiumPlan.Legacy]: {
        ...wixPremiumFeaturesStatusCreateFullyEnabled(DoppePremiumFeaturesSpec),
        ...createPartialPremiumFeaturesStatus([
            wixPremiumBooleanFeatureStatusCreate(DoppePremiumFeatures.hopp_remove_banner, false),
            wixPremiumBooleanFeatureStatusCreate(DoppePremiumFeatures.hopp_advanced_design_options, false),
        ])
    },
    [DoppeFreemiumPlan.Default]: {
        ...wixPremiumFeaturesStatusCreateFullyDisabled(DoppePremiumFeaturesSpec),
        ...createPartialPremiumFeaturesStatus([
            wixPremiumQuotaFeatureStatusCreate(DoppePremiumFeatures.hopp_add_items_to_list_action, {limit: 4})
        ])
    }
} satisfies {
    [plan in DoppeFreemiumPlan.Enabled]: DoppePremiumFeaturesStatus
}

export function doppeFreemiumPlanGetPremiumFeaturesStatus (
    freemiumPlan: DoppeFreemiumPlan.Enabled
) : DoppePremiumFeaturesStatus {
    return DoppeFreemiumPlanFeaturesStatus[freemiumPlan]
}